<template>
  <div class="pop" :class="{'show': show}">
    <div class="content" @click.stop>
      <div class="pop-title">立即咨询 <span class="close" @click="$emit('hideHotLine')"><img src="../assets/images/close.svg"></span></div>
      <div class="divider"></div>
      <a href="tel:15127099991" class="tel"><img src="../assets/images/tel.svg"> 15127099991 <div>热线#1<span>一触即达</span>好名驾到</div></a>
      <a href="tel:13073145881" class="tel"><img src="../assets/images/tel.svg"> 13073145881 <div>热线#2<span>一触即达</span>好名驾到</div></a>
      <div class="divider"></div>
      <div class="weixin">
        <h3>添加微信更方便，持续咨询！</h3>
        <p>长按号码并复制，打开微信搜索<br><code>13073145881</code><br>成为叶老师的好友，开始起名！</p>
        <img src="images/weixin.png" width="100%">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hot-line',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang=scss>
  .pop{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-color: rgba(0,0,0,.4);
    transition: .3s;
    opacity: 0;
    pointer-events: none;
    overflow: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    z-index: 10;
    .pop-title{
      line-height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: -10px;
    }
    .content{
      width: 320px;
      height: auto;
      background-color: #fff;
      border-radius: 5px;
      padding: 5px 12px 12px;
      transition: .3s;
      opacity: 0;
      margin: 30px 0;
      .tel{
        position: relative;
        line-height: 52px;
        background-color: #f3ebd4;
        font-size: 3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        outline: none;
        color: $red;
        font-family: fantasy;
        padding-top: 25px;
        & + .tel{
          margin-top: 10px;
        }
        > div{
          position: absolute;
          top: 12px;
          left: 0;
          width: 100%;
          height: 30px;
          overflow: hidden;
          text-align: center;
          margin: 0 auto;
          font-size: 1.6rem;
          color: #ef1f16;
          line-height: 1.2;
          font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
          span{
            padding: 0 10px;
          }
        }
        img {
          margin-right: 10px;
        }
      }
      .divider{
        border-top: #e9e9e9 1px solid;
        margin: 12px -12px;
      }
      .weixin{
        text-align: center;
        p {
          margin-top: 12px;
          line-height: 1.5rem;
        }
        code{
          background-color: #f3ebd4;
          padding: 20px 36px;
          border: #d2c9af thin dotted;
          font-size: 3rem;
          font-family: fantasy;
          color: $red;
          margin: 10px;
          display: inline-block;
        }
      }
    }
    &.show{
      opacity: 1;
      pointer-events: auto;
      .content {
        opacity: 1;
      }
    }
  }
</style>
